/**
 *
 *  Radio Patmos Now playing info refresh on header
 *      
 */

(function($) {
    function getType(t) {
        if (t == 59) {
            return "radio";
        }
        if (t == 61) {
            return "speech";
        }
        if (t == 53 || t == 54) {
            return "news";
        }
        if (t > 19 && t < 44) {
            return "music";
        }
        if (t > 65) {
            return "music";
        }
        return "";
    }

    function getData(data) {
        var rv = {
            title: "",
            name: "",
            type:"",
            current_state: 0
        };
        rv.scheduled_time = data.themes.current.theme_schedule;

        // resolve percent
        var next = data.themes.next.theme_schedule;
        var d = new Date();
        var hoursnow = d.getHours();
        var minutesnow = d.getMinutes();
        var secondsnow = d.getSeconds();
        var split = rv.scheduled_time.split(":");
        var split2 = next.split(":");
        var hdiff = parseInt(split[0]) - hoursnow;
        var mdiff = parseInt(split[1]) - minutesnow;
        var sdiff = parseInt(split[2]) - secondsnow;
        var secElapsed = hdiff*3600 + mdiff*60 + sdiff;

        hdiff = parseInt(split[0]) - parseInt(split2[0]);
        mdiff = parseInt(split[1]) - parseInt(split2[1]);
        sdiff = parseInt(split[2]) - parseInt(split2[2]);
        var secTotal = hdiff*3600 + mdiff*60 + sdiff;
        rv.current_state = 100.0 * secElapsed / secTotal;

        if (typeof(data.titles.current) == "undefined") {
            // no current, use theme text
            if (typeof(data.themes.current) == "undefined") {
                // no data in themes either, return empty texts - should not happen
                return rv;
            }
            rv.title = data.themes.current.title;
            if (rv.title == "") {
                // no title, fallback to theme title
                rv.title = data.themes.current.theme_title;
            }
            rv.name = data.themes.current.name;
            return rv;
        }
         
        var c = data.titles.current;
        rv.title = c.title;
        rv.name = c.name;
        rv.end_time = c.est_end_time;

        // check type
        rv.type = getType(c.type);
        return rv;
    }

    function updateNowPlaying(data) {
        if (typeof(data.titles) == "undefined") {
            $('#header-now-playing-info').html("<div></div>")
            return;
        }

        var now = getData(data);

        //var icon = "";
        //if (now.type == "music") {
        //    icon = '<span>&#x266B;</span> ';
        //} 
        var html = "";
        if (now.title == "") {
          html = 'Nyt: ' + now.name;
        } else {
          html = 'Nyt: ' + now.title;
          if (now.name != '') {
              html += "<br>" + now.name;
          }
        }

        $('#header-now-playing-info').html(html);
    } 

  $(document).ready(function() {
    var path = "/wp-content/uploads/zenon/listening_now.json";
    
    $.getJSON(path, function (result) {
        updateNowPlaying(result);
    })

    setInterval(function() {
      $.getJSON(path, function (result) {
        updateNowPlaying(result);
    });}, 60000);
  });

})(jQuery);
